import React, { useState } from 'react';
import UploadFile from 'components/Utils/UploadFile';
import DefaultTextField from 'components/Utils/DefaultTextField';
import MiscUtils from 'services/MiscUtils';
import PerformanceUtils from 'services/PerformanceUtils';
import DocumentUtils from 'services/DocumentUtils';
import DefaultSelectField from 'components/Utils/DefaultSelectField';
import PatientBadge from 'components/Patient/PatientBadge/index';
import Icon from 'components/Utils/NewIcon/index';
import DocumentPreview from 'components/Utils/DocumentPreview';
import './style.scss';
import DefaultButton from 'components/Utils/NewDefaultButton';
import DocumentTemplateList from 'components/HealthRecords/Documents/DocumentTemplateList';
import { useAppSelector } from 'careand-redux/store';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';
import NewReferralAdmin from 'components/HealthRecords/Documents/NewReferralAdmin';

const SCREENS = {
  select: 'select',
  upload: 'upload',
  template: 'template',
  referral: 'referral',
};

const AddDocument = ({ patient, onSave, initialScreen }) => {
  const [screen, setScreen] = useState(initialScreen || SCREENS.select);

  let className = 'add-document rounded';

  return (
    <div className={className}>
      <div className="title">
        {screen !== SCREENS.select && (
          <Icon src="arrow-left" className="back" onClick={() => setScreen(SCREENS.select)} />
        )}
        Add Document
        <Icon src="xmark" className="close" onClick={onSave} />
      </div>
      <div className="main-content scroll-list">
        {screen === SCREENS.select && (
          <div className="select-screen padded-box">
            <span className="mb-3">Please select an option below:</span>
            <DefaultButton
              name="Upload File"
              icon="upload"
              onClick={() => setScreen(SCREENS.upload)}
            />
            <DefaultButton
              name="Select Template"
              icon="files-medical"
              onClick={() => setScreen(SCREENS.template)}
            />
            <DefaultButton
              name="Create Referral"
              icon="user-doctor"
              onClick={() => setScreen(SCREENS.referral)}
            />
          </div>
        )}
        {screen === SCREENS.upload && <UploadFileScreen patient={patient} onSave={onSave} />}
        {screen === SCREENS.template && <SelectTemplateScreen patient={patient} onSave={onSave} />}
        {screen === SCREENS.referral && (
          <div className="p-2">
            <NewReferralAdmin patient={patient} onClose={onSave} />
          </div>
        )}
      </div>
    </div>
  );
};

const HIDE_CATEGORIES = [DocumentUtils.DOCUMENT_TYPE.referral + 's'];

export const SelectTemplateScreen = ({ patient, onSave }) => {
  const physicians = useAppSelector((state) => state.physicians.byId);
  const physician = physicians[patient.primary_physician];

  return (
    <div className="select-template-screen padded-box">
      <DocumentTemplateList
        patient={patient}
        physician={physician}
        showSecondaryName={true}
        secondaryCollapse={true}
        hideAddButton={true}
        onSaveCompleted={onSave}
        allowSave={true}
        hideCategories={HIDE_CATEGORIES}
      />
    </div>
  );
};

const UploadFileScreen = ({ patient, onSave }) => {
  const dispatch = useAppDispatch();

  const [document, setDocument] = useState({
    title: '',
    document_type: DocumentUtils.DOCUMENT_TYPE.other,
  });
  const [url, setUrl] = useState();
  const [type, setType] = useState();

  function onValueChanged(event) {
    let name = event.target.name;
    let value = event.target.value;
    setDocument((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  }

  async function submitFile(file) {
    let { title, document_type } = document;

    let approved = false;

    if (!title) return;

    let result = await dispatch(
      api.Documents.addDocument({
        title,
        file,
        approved,
        documentType: document_type,
        id: patient.id,
      }),
      {
        title: 'Document Upload',
        successText: 'Document uploaded successfully!',
      },
    );
    if (result) {
      if (onSave !== undefined) onSave();
    }

    return !!result;
  }

  let className = 'upload-document-screen';

  const buttonDisabled = !document.title || !url;

  return (
    <div className={className}>
      <div className="document-form padded-box">
        <PatientBadge patient={patient} />
        <DefaultTextField
          name="title"
          placeholder="Title"
          value={document.title}
          onChange={onValueChanged}
        />
        <DefaultSelectField
          label="Type"
          name="document_type"
          value={document.document_type}
          style={{ width: '100%' }}
          onChange={onValueChanged}
          inputs={PerformanceUtils.objectToArray(DocumentUtils.DOCUMENT_TYPE)}
        />
        <UploadFile
          title="Upload patient document"
          hideButton={false}
          accept="image/jpeg, image/png, application/pdf"
          disabled={buttonDisabled}
          onSubmit={submitFile}
          onDrop={(file) => {
            setType(file.type);
            setUrl(MiscUtils.getBlobUrl(file));
          }}
        />
      </div>
      {url ? <DocumentPreview url={url} type={type} /> : null}
    </div>
  );
};

export default AddDocument;
